import { IconButton } from "@material-ui/core";
import Tooltip from "screens/ContentTab/features/common/Tooltip";
import TypedIcon from "../common/TypedIcon";
const NotificationGroupIndicator = ({ group, onClick }) => (<Tooltip title={group.name}>
    <IconButton style={{ color: "white" }} className="NotificationIcon-button" onClick={onClick} data-identification={`notification-${group.name}`}>
      <TypedIcon badge={<b className="NotificationIcon-badge" style={{ background: group.background, color: group.color }}>
            {group.count}
          </b>} className="NotificationIcon" size={group.iconSet.startsWith("material-icons") ? 19 : 16} type={group.iconSet}>
        {group.icon}
      </TypedIcon>
    </IconButton>
  </Tooltip>);
export default NotificationGroupIndicator;
